import {renameSiteSlug} from '@/api/sites';
import {useMutation, useQueryClient} from '@tanstack/react-query';

export function useRenameSiteSlug(siteId: string) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (slug: string) => renameSiteSlug(siteId, slug),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['sites']});
            queryClient.invalidateQueries({queryKey: ['site', siteId]});
            queryClient.invalidateQueries({queryKey: ['site-slug-check', siteId]});
        }
    });
}
